import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../../utils/analytics";

export default function ScrollToTop() {
    const { pathname, search, hash } = useLocation();
    const isFirstRender = useRef(true);

    useEffect(() => {
        // The initial load's page_view is already sent by the gtag config snippet
        // in index.html. react-router navigates client-side after that, so every
        // route change past the first one needs its own manual page_view.
        if (isFirstRender.current) {
            isFirstRender.current = false;
        } else {
            trackPageView(pathname + search);
        }

        // If you use hash links like /page#section, scroll to that section.
        if (hash) {
            const el = document.querySelector(hash);
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
                return;
            }
        }

        // Default behavior: always go to top on route changes
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [pathname, search, hash]);

    return null;
}
